<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.renderWithTitle()
  },
  watch: {
    chartdata() {
      this.renderWithTitle()
    },
    title() {
      this.renderWithTitle()
    },
  },
  methods: {
    renderWithTitle() {
      const clonedOptions = JSON.parse(JSON.stringify(this.options || {}))

      if (!clonedOptions.tooltips) clonedOptions.tooltips = {}
      if (!clonedOptions.tooltips.callbacks) clonedOptions.tooltips.callbacks = {}

      // Override callback để chèn title từ prop
      clonedOptions.tooltips.callbacks.label = (tooltipItem, data) => {
        const dataset = data.datasets[tooltipItem.datasetIndex]
        const value = dataset.data[tooltipItem.index]
        const total = dataset.data.reduce((a, b) => a + b, 0)
        const percent = ((value / total) * 100).toFixed(1)
        const label = data.labels[tooltipItem.index]
        return `${label}: ${percent}% - ${total} ${this.title}`
      }

      if (!clonedOptions.legend) {
        clonedOptions.legend = {
          position: 'bottom',
          labels: {
            boxWidth: 16,
            padding: 8,
          },
        }
      }

      // Vẽ lại biểu đồ
      this.renderChart(this.chartdata, {
        responsive: true,
        maintainAspectRatio: false,
        ...clonedOptions,
      })
    },
  },
}
</script>
